import { useTranslation } from 'react-i18next';
import { ModalComponentWrapper } from '@/shared/components';
import { MfaConfirmationScreen } from '@/entities/mfa-identity';
import { sendTwoFactorIdentityCode } from '../api/requests';
import { useMemo, useState } from 'react';
import {
  type PhoneVerificationTwoFactorIdentityModalArgs,
  usePhoneVerificationTwoFactorIdentityForm,
} from '@/features/user-settings-phone/model';

const PhoneVerificationTwoFactorIdentityModal = ({
  identityType,
  identity,
  onBack,
  onSuccess,
  maskedContact: propMaskedContact,
  expiresIn,
  resendIn,
  length,
}: PhoneVerificationTwoFactorIdentityModalArgs) => {
  const { t } = useTranslation();
  const localePath = 'authPages.identityConfirmationForm';
  const [maskedContact, setMaskedContact] = useState(propMaskedContact ?? '');

  const {
    form,
    isVerifyPhoneTwoFactorLoading,
    verifyPhoneTwoFactorSubmit,
    verifyPhoneTwoFactorError,
  } = usePhoneVerificationTwoFactorIdentityForm({
    identityType,
    identity,
    onSuccess,
  });

  const descriptionText = useMemo(() => {
    return maskedContact
      ? t(`${localePath}.description`) + ' ' + maskedContact
      : '';
  }, [identityType, t, localePath, maskedContact]);

  return (
    <ModalComponentWrapper
      title={t(`${localePath}.title`)}
      titleClassName={`headline0`}
      contentClassName={'overflow-hidden'}
      description={descriptionText}
      onBack={onBack}>
      <MfaConfirmationScreen
        resendIn={resendIn}
        expiresIn={expiresIn}
        length={length}
        form={form}
        identityType={identityType}
        mfaCodeFieldName="code"
        identity={identity}
        sendOtpCodeMutationFn={sendTwoFactorIdentityCode}
        setMaskedContact={setMaskedContact}
        onSubmit={verifyPhoneTwoFactorSubmit}
        isSubmitLoading={isVerifyPhoneTwoFactorLoading}
        submitError={verifyPhoneTwoFactorError?.message}
        isInitialSetup
        shouldSendOtpOnMount={false}
      />
    </ModalComponentWrapper>
  );
};

export { PhoneVerificationTwoFactorIdentityModal };
